import { FC } from 'react';
import { Button } from '@gravity-ui/uikit';
import { commonT, pageT } from '../../../i18n';

type MobileBottomBarBaseProps = {
    mode: 'list' | 'upload';
};

type ListModeProps = MobileBottomBarBaseProps & {
    mode: 'list';
    canGoPrev: boolean;
    canGoNext: boolean;
    onPrev: () => void;
    onNext: () => void;
    onUploadOpen: () => void;
};

type UploadModeProps = MobileBottomBarBaseProps & {
    mode: 'upload';
    isUploading: boolean;
    canSubmit: boolean;
    onSubmit: () => void;
    onCancel: () => void;
};

type MobileBottomBarProps = ListModeProps | UploadModeProps;

export const MobileBottomBar: FC<MobileBottomBarProps> = (props) => {
    if (props.mode === 'upload') {
        return (
            <div className="mobile-bottom-bar mobile-bottom-bar--upload">
                <Button
                    className="mobile-bottom-bar__btn--primary"
                    view="action"
                    size="l"
                    loading={props.isUploading}
                    disabled={!props.canSubmit || props.isUploading}
                    onClick={props.onSubmit}
                >
                    {commonT('upload')}
                </Button>
                <Button
                    className="mobile-bottom-bar__btn"
                    view="outlined"
                    size="l"
                    disabled={props.isUploading}
                    onClick={props.onCancel}
                >
                    {commonT('cancel')}
                </Button>
            </div>
        );
    }

    return (
        <div className="mobile-bottom-bar">
            <Button
                className="mobile-bottom-bar__btn"
                view="outlined"
                size="l"
                disabled={!props.canGoPrev}
                onClick={props.onPrev}
            >
                ←
            </Button>
            <Button
                className="mobile-bottom-bar__btn--primary"
                view="action"
                size="l"
                onClick={props.onUploadOpen}
            >
                {pageT('videoUploadShort')}
            </Button>
            <Button
                className="mobile-bottom-bar__btn"
                view="outlined"
                size="l"
                disabled={!props.canGoNext}
                onClick={props.onNext}
            >
                →
            </Button>
        </div>
    );
};
